'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping'),
    util = require('../../util'),
    internationalshipping = require('../../internationalshipping'),
    formFields = require('./../../components/formFields'),
    tealium = require('../../../../../int_tealium/cartridge/js/tealium/tealium');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    util.questionAndAnwserEvent();
    // Global Forms
    formFields.init();
    function checkoutHeader() {
    	if($(window).width() < 768) {
        	var $chekoutheader = $('.fixed-header').outerHeight();
        	$('.pt_checkout #main').css({'padding-top': $chekoutheader});
        }
        // IE11 Fix only
        if(util.isIE()){
            $(".primary-logo a").attr("tabindex","-1");              
        }
    }
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }
    $("body").off("click",".help-click").on("click",".help-click",function(){
    	var $parent = $(this).closest(".chk-out-header-right-section");
    	if(!$parent.hasClass("active")) {
    		$parent.addClass("active");
    		$(this).attr("aria-expanded","true");
    	} else {
    		$parent.removeClass("active");
    		$(this).attr("aria-expanded","false");
    	}
    	checkoutHeader();
    });
    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }
    //SM-3041 - Error Message Tracking For CVV and AVS Validation
    $(window).load(function() {
    	if($('.error-form.plcaeordererror').length > 0 && $('.cardtype_tealiumTracking').length > 0){
    	 	var cardType = $('.cardtype_tealiumTracking').val(); 
        	var eventData = {
    				event_name: "error_form",
    				error_form_response: "checkout:payment information or billing:"+cardType
    		}                
    		tealium.triggerEvent(eventData);
        }	
    });    

    checkoutHeader();

    $('body').off('click', '.intl-shipping-btn').on('click', '.intl-shipping-btn', function (e) {
        e.preventDefault();
        internationalshipping.getCountrySelectionModal(false);
        var eventData = {
            "event_name": "international_shipping", 
            "location": "checkout"
        };
        tealium.triggerEvent(eventData);
    }).show();

    $('body').off('click', '#international-modal-submit').on('click', '#international-modal-submit', function (e) {
        internationalshipping.formSubmit(e);   
    });  
    
    /* SC-11053, SC-11016, SC-11025 */
    $("body").on("change", ".smsSignUp input[type=checkbox]", function(){
        var isChecked = $(this)[0].checked;
        $(".smsSignUp input[type=checkbox]").each(function(){
            $(this)[0].checked = isChecked;
        });
    });
    /* End: SC-11053, SC-11016, SC-11025 */
};
